import { useParams } from "../../../../router-utils"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { SupplierDetails } from "../../../../Supplier"
import { Outlet } from "react-router"

export default function Supplier() {
	const { supplierId } = useParams("/suppliers/:supplierId")
	return (
		<ForbidUnlessAuthorized
			anyPermissions={[
				PERMISSIONS.VIEW_TRANSPORT_SERVICE_PROVIDERS,
				PERMISSIONS.VIEW_HOTEL_SUPPLIERS,
			]}
		>
			<SupplierDetails supplierId={supplierId}>
				{({ transportServiceProvider, revalidate }) => (
					<Outlet
						context={{
							transportServiceProvider,
							revalidate,
						}}
					/>
				)}
			</SupplierDetails>
		</ForbidUnlessAuthorized>
	)
}
